(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["td-pdp-styles"] && !Shopify.designMode) return;
  try {
    (() => {



  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const seen = new WeakSet();

  const running = new Map();

  const targets = '.td-pdp__header,.td-pdp__carry,.td-pdp__inside-media,.td-pdp__inside-copy,.td-pdp__feature-card,.td-pdp__step,.td-pdp__service-item,.td-pdp__accordion,.td-pdp__return';

  const observer = ('IntersectionObserver' in window) ? new IntersectionObserver(entries => {

    for (const entry of entries) {

      if (!entry.isIntersecting) continue;

      const node=entry.target; observer.unobserve(node);

      if (seen.has(node) || reduced.matches) continue;

      seen.add(node);

      if (!node.animate) continue;

      const compact=window.innerWidth<768;

      const animation=node.animate([{opacity:0,transform:'translateY('+ (compact?14:22) +'px)'},{opacity:1,transform:'translateY(0)'}],{duration:compact?480:680,delay:Number(node.dataset.tdMotionDelay||0),easing:'cubic-bezier(.2,.65,.3,1)',fill:'backwards'});

      running.set(node,animation);

      animation.finished.then(()=>running.delete(node),()=>running.delete(node));

    }

  },{threshold:.12,rootMargin:'0px 0px -24px 0px'}) : null;

  function initMotion(root=document){

    if (!observer || reduced.matches || window.Shopify?.designMode) return;

    root.querySelectorAll(targets).forEach(node=>{

      if (!node.closest('.td-pdp') || seen.has(node)) return;

      const index=Array.from(node.parentElement.children).indexOf(node);

      node.dataset.tdMotionDelay=String(node.matches('.td-pdp__carry,.td-pdp__feature-card,.td-pdp__step,.td-pdp__service-item')?Math.min(index,2)*90:0);

      observer.observe(node);

    });

  }

  function cancelWithin(root){for(const [node,animation] of running){if(root===document||root.contains(node)){animation.cancel();running.delete(node);}}}

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initMotion(),{once:true});else initMotion();

  document.addEventListener('shopify:section:load',event=>initMotion(event.target));

  document.addEventListener('shopify:section:unload',event=>{event.target.querySelectorAll(targets).forEach(node=>observer?.unobserve(node));cancelWithin(event.target);});

  document.addEventListener('shopify:section:select',event=>cancelWithin(event.target));

  document.addEventListener('shopify:block:select',event=>cancelWithin(event.target));

  reduced.addEventListener('change',()=>{if(reduced.matches){observer?.disconnect();cancelWithin(document);}else initMotion();});



  document.addEventListener('click', (event) => {

    const back = event.target.closest?.('[data-td-return-product], .td-pdp a[href="#MainContent"]');

    if (!back) return;

    const target = document.querySelector('[data-product-decision]') || document.querySelector('.product-information') || document.querySelector('[id^="ProductInformation-"]') || document.querySelector('form[action*="/cart/add"]') || document.querySelector('#MainContent');

    if (!target) return;

    event.preventDefault();

    target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});

    const input=Array.from(target.querySelectorAll('select,input:not([type="hidden"]),button,a')).find(el=>!el.hidden&&el.getAttribute('aria-hidden')!=='true'&&el.getClientRects().length);

    if(input) input.focus({preventScroll:true});

  });

  document.addEventListener('shopify:block:select', event => {

    const detail=event.target.closest?.('.td-pdp details') || event.target.querySelector?.('.td-pdp details');

    if(detail)detail.open=true;

  });

  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('video').forEach(v=>v.pause()));

})();
  } catch(e) { console.error(e); }
})();

})();
